<template>
  <div>
    <div class="filter-wrapper">
      <md-field>
        <label>Provider</label>
        <md-select
          id="provider-select"
          v-model="provider"
          name="provider"
          label="provider"
          :disabled="loading"
          class="md-layout-item md-size-20"
        >
          <md-option value="ProVPN">
            ProVPN
          </md-option>
          <md-option value="Nord">
            Nord
          </md-option>
        </md-select>
      </md-field>

      <country-selector-with-continents
        :hide-mode="true"
        :show-label="true"
        @countryListChanged="changeCountryList"
      />

      <md-field>
        <label>Protocol</label>
        <md-select
          id="protocol"
          v-model="protocolFilter"
          class="md-select-menu"
          name="protocol"
          @md-selected="filterNodes"
        >
          <md-option
            class="md-select-value"
            value="All"
          >
            All
          </md-option>
          <md-option
            class="md-select-value"
            value="OpenVPN_UDP"
          >
            OpenVPN UDP
          </md-option>
          <md-option
            class="md-select-value"
            value="OpenVPN_TCP"
          >
            OpenVPN TCP
          </md-option>
          <md-option
            class="md-select-value"
            value="IKEv1"
          >
            IKEv1
          </md-option>
          <md-option
            class="md-select-value"
            value="IKEv2"
          >
            IKEv2
          </md-option>
          <md-option
            class="md-select-value"
            value="L2TPOverIPSEC"
          >
            L2TPOverIPSEC
          </md-option>
          <md-option
            class="md-select-value"
            value="GRPC"
          >
            GRPC
          </md-option>
          <md-option
            class="md-select-value"
            value="LocalDNS"
          >
            LocalDNS
          </md-option>
          <md-option
            class="md-select-value"
            value="CustomDNSConfigurations"
          >
            CustomDNSConfigurations
          </md-option>
          <md-option
            class="md-select-value"
            value="Hysteria2"
          >
            Hysteria2
          </md-option>
        </md-select>
      </md-field>

      <server-bundles-filter @onBundlesFilterUpdate="updateBundlesFilter" />

      <md-checkbox
        v-model="onlyEnabled"
        @change="filterNodes"
      >
        Only Enabled
      </md-checkbox>
    </div>

    <md-progress-bar
      v-if="loading"
      md-mode="query"
    />
    <v-client-table
      v-else
      :data="filteredNodes"
      :columns="tableColumns"
      :options="tableOptions"
      class="nodes-table"
    >
      <template #enabled="{ row }">
        <md-checkbox
          v-model="row.is_enabled"
          @change="enableNode(row)"
        />
      </template>

      <template #secret="{ row }">
        <md-icon
          v-clipboard:copy="row.secret"
          class="gen-key"
        >
          assignment
        </md-icon>
      </template>

      <template #location="{ row }">
        {{ row.location ? row.location.countryCode: "" }}
      </template>

      <template #comment="{ row }">
        <p class="fixed-width-column">
          {{ row.comment }}
        </p>
      </template>

      <template #server_bundles="{ row }">
        <div
          class="fixed-width-column bundle-bubble"
          @click="onBundlesClick(row)"
        >
          <md-chip
            v-for="sb in row['server_bundles']"
            :key="sb.id"
            class="md-primary bundle-bubble"
            md-static
          >
            {{ sb.name }}
          </md-chip>
        </div>
      </template>

      <template #edit="{ row }">
        <a
          :href="'/node/edit/' + row.id"
          target="_blank"
        >
          <md-icon class="gen-key">create</md-icon>
        </a>
      </template>

      <template #info="{ row }">
        <md-icon
          class="gen-key"
          @click.native="getNodeByID(row)"
        >
          info
        </md-icon>
      </template>

      <template #delete="{ row }">
        <md-icon
          class="gen-key"
          @click.native="openDeleteDialog(row.id)"
        >
          delete
        </md-icon>
      </template>
    </v-client-table>

    <md-dialog
      class="node-details"
      :md-active.sync="showDetailsDialog"
    >
      <md-dialog-title>Node configuration</md-dialog-title>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="showDetailsDialog = false"
        >
          Close
        </md-button>
      </md-dialog-actions>

      <md-dialog-content>
        <pre>{{ JSON.stringify(nodeDetails, null, 4) }}</pre>
      </md-dialog-content>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="deleteDialogActive"
      md-title="Delete node?"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-cancel="closeDeleteDialog()"
      @md-confirm="deleteNode(deleteNodeId)"
    />

    <server-bundle-dialog
      :show-bundles-dialog.sync="showBundlesDialog"
      :node="bundleEditNode"
      :on-close="onBundleDialogClose"
    />
  </div>
  <!--    Total: {{total}}-->
</template>

<script>
    import CountrySelectorWithContinents from "@/components/Forms/Fields/CountrySelectorWithContinents";
    import ServerBundlesFilter from "@/components/Forms/Fields/ServerBundlesFilter";
    import ServerBundleDialog from "../Forms/nodes/ServerBundleDialog";

    export default {
        name: "NodesTable",
        components: {CountrySelectorWithContinents, ServerBundlesFilter, ServerBundleDialog},
        props: {
            tableHeaderColor: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                provider: "ProVPN",
                notifications: {
                    topCenter: false
                },
                loading: true,
                tags: ["test"],
                total: 0,
                selected: [],
                nodes: [
                    {
                        id: "",
                    }
                ],
                componentKey: 0,
                showDetailsDialog : false,
                nodeDetails : {
                    id : "",
                    protocol : "",
                    ip: "",
                },

                countryFilter: [],
                protocolFilter: "OpenVPN_TCP",
                onlyEnabled: false,

                filteredNodes: [],

                deleteDialogActive: false,
                deleteNodeId: "",

                serverBundlesFilter: "",

                filtersChain: [
                    (nodes) => this.filterEnabled(nodes, this.onlyEnabled),
                    (nodes) => this.filterByProtocol(nodes, this.protocolFilter),
                    (nodes) => this.filterByCountry(nodes, this.countryFilter),
                    (nodes) => this.filterByBundle(nodes, this.serverBundlesFilter),
                ],

                tableColumns: ["enabled", "protocol", "ip", "server_address", "port", "secret", "location",
                    "comment", "server_bundles", "edit", "info", "delete"],
                tableOptions: {
                    perPage: 200,
                    sortable: ["enabled", "protocol", "ip", "port", "location"],
                },

                showBundlesDialog: false,
                bundleEditNode: null,
            };
        },
        watch: {
            provider() {
                this.getNodes();
            },
            protocolFilter() {
                this.getNodes();
                this.filterNodes();
            }
        },
        mounted() {
            this.getNodes();
        },
        methods: {
            getNodeByID(item) {
                this.showDetailsDialog = true;

                this.$http.get("/v1/admin/node?id="+item.id).then(result => {
                    this.nodeDetails = result.data;
                }, err => {
                    console.error(err);
                });
            },
            enableNode(item) {
                let body = {
                    "enable" : item.is_enabled,
                    "node_id" : item.id,
                };
                const action = item.is_enabled ? "enabled" : "disabled";

                this.$http.put("/v1/admin/node/enable", body).then(() => {
                    this.$notify({
                        group: "foo",
                        title: "Node " + action,
                    });

                    this.nodes = this.nodes.map(n => {
                        if (n.id === item.id) {
                            n.is_enabled = !n.is_enabled;
                        }
                        return n;
                    });
                    this.filterNodes();
                }, () => {
                    this.$notify({
                        group: "foo",
                        title: "Cannot change node state",
                        type: "warn"
                    });
                });
            },
            deleteNode(id) {
                this.$http.delete("/v1/admin/node/delete?id=" + id).then(() => {
                    this.$notify({
                        group: "foo",
                        title: "Node deleted",
                    });

                    this.nodes = this.nodes.filter(n => n.id !== id);
                    this.filteredNodes = this.filteredNodes.filter(n => n.id !== id);
                },
                err => {
                    this.errorMsg = err.response.data.message;
                });
            },
            openDeleteDialog(nodeId) {
                this.deleteDialogActive = true;
                this.deleteNodeId = nodeId;
            },
            closeDeleteDialog() {
                this.deleteDialogActive = false;
                this.deleteNodeId = "";
            },
            getNodes() {
                this.loading = true;

                const protocolParam = this.protocolFilter === "All" ? "" : `&filters.protocols=${this.protocolFilter}`;
                // get nodes
                this.$http.get(`/v1/admin/nodes?filters.provider=${this.provider}${protocolParam}`).then(result => {
                    this.nodes = result.data.nodes;
                    this.filteredNodes = result.data.nodes;
                    this.loading = false;
                }, err => {
                    console.error(err);
                });
            },
            filterByCountry(nodes, countryFilter) {
                if (countryFilter.length === 0) {
                    return nodes;
                }
                return nodes.filter(n => countryFilter.includes(n.location.countryCode));
            },
            filterByProtocol(nodes, protocol) {
                if (protocol === "All") {
                    return nodes;
                }
                return nodes.filter(n => n.protocol === protocol);
            },
            filterEnabled(nodes, onlyEnabled) {
                if (!onlyEnabled) {
                    return nodes;
                }
                return nodes.filter(n => n.is_enabled);
            },
            filterByBundle(nodes, bundle) {
                if (bundle === "") {
                    return nodes;
                }
                return nodes.filter(n => n.server_bundles.some(b => b.name === bundle));
            },
            filterNodes() {
                this.filteredNodes = this.filtersChain.reduce((nodes, filter) => filter(nodes), this.nodes);
            },
            changeCountryList(newList) {
                this.countryFilter = newList;
                this.filterNodes();
            },
            updateBundlesFilter(newBundlesValue) {
                this.serverBundlesFilter = newBundlesValue;
                this.filterNodes();
            },
            onBundlesClick(node) {
                this.showBundlesDialog = true;
                this.bundleEditNode = node;
            },
            onBundleDialogClose(nodeId, newServerBundles) {
                this.showBundlesDialog = false;

                if (nodeId && newServerBundles) {
                    this.nodes.find(n => n.id === nodeId).server_bundles = newServerBundles;
                    this.filteredNodes.find(n => n.id === nodeId).server_bundles = newServerBundles;
                }
            }
        }
    };
</script>
<style lang="scss">
    .nodes-table {
      word-wrap: break-word !important;

      td {
        text-align: center;
      }

      th:nth-child(8) {
        max-width: 300px;
        word-wrap: break-word !important;
      }

      td:nth-child(8) {
        max-width: 300px;
        word-wrap: break-word !important;
        text-align: left;
      }

      td:nth-child(9) {
        max-width: 300px;
        word-wrap: break-word !important;
        text-align: left;
      }
    }
</style>
<style scoped lang="scss">
    body {
      background-color: #c8c8c8 !important !important !important;
    }

    div.filter-wrapper {
        display: flex;

        div {
          width: auto;
          margin-right: 15px;
        }
    }

    .fixed-width-column {
        max-width: 300px;
    }

    .node-details {
        padding: 50px 100px;
    }

    .gen-key {
        cursor: pointer !important;
    }

    .gen-key:active {
        position: relative;
        top: 2px;
    }

    .bundle-bubble {
      cursor: pointer;
    }
</style>
